import { Link } from "react-router-dom"

import {
    APP_PAGE_URL,
    PERCENT_OF_SELECTED_PSYCHOLOGISTS,
    PSYALTER_SUPPORT_EMAIL,
} from "utils/env-management"

export const aboutWorkWithPsychologist = {
    title: <>О&nbsp;работе с&nbsp;психологом</>,
    content: [
        {
            title: "Как проходит первая сессия",
            content: (
                <>
                    На&nbsp;первой сессии обычно происходит знакомство с&nbsp;терапевтом
                    и&nbsp;уточнение запроса. Никто не&nbsp;будет требовать от&nbsp;вас сразу
                    рассказывать очень личные вещи или погружаться в&nbsp;прошлое. Психолог задаст
                    вам несколько вопросов о&nbsp;вашей жизни, ваших недовольствах и&nbsp;сложностях
                    и&nbsp;целях в&nbsp;психотерапии. Это нужно, чтобы психолог понимал, как
                    выстраивать дальнейшую работу.
                </>
            ),
        },
        {
            title: <>Как подготовиться к&nbsp;первой сессии</>,
            content: (
                <>
                    <p className="mb-3">
                        Обычно никакая специальная подготовка не&nbsp;нужна. Но, если у&nbsp;вас
                        есть время, можете поразмышлять над этими вопросами&nbsp;— они помогут лучше
                        определить свои цели и&nbsp;ожидания от&nbsp;терапии:
                    </p>

                    <ul className="list-disc ml-0 pl-3 sb-3 mb-3">
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                С&nbsp;какими сложностями вы&nbsp;сейчас сталкиваетесь?
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Какие сферы жизни вас сейчас не&nbsp;устраивают?
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Что вы&nbsp;хотели&nbsp;бы изменить в&nbsp;себе и&nbsp;своей жизни?
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                К&nbsp;чему вы&nbsp;хотели&nbsp;бы прийти после терапии?
                            </span>
                        </li>
                    </ul>
                </>
            ),
        },
        {
            title: <>Как вести себя во&nbsp;время сессии</>,
            content: (
                <>
                    <p className="mb-3">
                        Мы&nbsp;понимаем, что на&nbsp;первой сессии может быть сложно расслабиться:
                        приходится говорить о&nbsp;личных вещах с&nbsp;почти незнакомым человеком.
                        Но&nbsp;терапевт не&nbsp;будет вас осуждать или критиковать. Его главная
                        задача&nbsp;— помочь вам.
                    </p>
                    <p className="mb-3">
                        Кроме того, один из&nbsp;профессиональных навыков терапевта&nbsp;— создавать
                        доверительную спокойную атмосферу. Поэтому не&nbsp;переживайте
                        и&nbsp;постарайтесь просто говорить максимально искренне. Но&nbsp;если
                        вы&nbsp;пока не&nbsp;готовы о&nbsp;чем-то говорить&nbsp;—
                        не&nbsp;заставляйте себя.{" "}
                    </p>
                </>
            ),
        },
        {
            title: "Сколько длится сессия",
            content: (
                <>
                    <p className="mb-3">
                        Чаще всего индивидуальная сессия с&nbsp;психологом длится 55&nbsp;мин.
                        Семейная или парная терапия&nbsp;— 1&nbsp;час 20&nbsp;минут. Обратите
                        внимание, что у&nbsp;разных специалистов длительность может отличаться.
                    </p>
                    <p className="mb-3">
                        Точная длительность сессий указана в&nbsp;разделе «Стоимость сессий»
                        на&nbsp;странице психолога.
                    </p>
                </>
            ),
        },
        {
            title: "Сколько нужно сессий",
            content: (
                <>
                    <p className="mb-3">
                        Определить это заранее сложно. Длительность терапии зависит от&nbsp;разных
                        факторов, например:
                    </p>
                    <ul className="list-disc ml-0 pl-3 sb-3 mb-3">
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Направление, в&nbsp;котором работает терапевт.
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Ваши индивидуальные особенности (кому-то легко говорить
                                о&nbsp;личном и&nbsp;рефлексировать, кому-то на&nbsp;это нужно
                                больше времени).
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Сложность запроса (с&nbsp;затяжной депрессией работать дольше, чем
                                с&nbsp;проблемой выбора профессии).
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Результата терапии, который вы&nbsp;ожидаете.
                            </span>
                        </li>
                    </ul>
                    <p className="mb-3">
                        Количество сессий зависит от&nbsp;вашего случая. Некоторые вопросы можно
                        проработать и&nbsp;почувствовать себя лучше за&nbsp;6–10&nbsp;сессий,
                        а&nbsp;некоторые темы требуют более длительной работы&nbsp;— до&nbsp;года.
                    </p>
                </>
            ),
        },
        {
            title: <>Как часто нужно встречаться с&nbsp;психологом</>,
            content: (
                <>
                    Как правило, на&nbsp;первом этапе терапии частота встреч&nbsp;&mdash; раз
                    в&nbsp;неделю. Это оптимально: клиент может полноценно погрузиться
                    в&nbsp;работу, при этом успевает делать домашние задания (если они есть)
                    от&nbsp;психолога и&nbsp;отслеживать изменения в&nbsp;своей жизни. Потом,
                    по&nbsp;договоренности, можно встречаться с&nbsp;психологом реже.
                    В&nbsp;кризисных и&nbsp;острых состояниях частота встреч может быть 2&ndash;3
                    раза в&nbsp;неделю.
                </>
            ),
        },
        {
            title: <>Как проходит работа с&nbsp;терапевтом</>,
            content: (
                <>
                    <p className="mb-3">
                        Все зависит от&nbsp;подхода. Сейчас существует от&nbsp;600 до&nbsp;1000
                        психотерапевтических подходов. Мы&nbsp;в&nbsp;Alter выступаем только
                        за&nbsp;те, которые признаны международным профессиональным сообществом.
                    </p>
                    <p className="mb-3">
                        Выбор направления зависит от&nbsp;того, с&nbsp;каким запросом пришел клиент,
                        и&nbsp;от&nbsp;его индивидуальных особенностей. Например, для работы
                        с&nbsp;депрессией чаще всего рекомендуют когнитивно-бихевиоральное
                        направление, а&nbsp;для поиска цели в&nbsp;жизни&nbsp;— экзистенциальное.
                        Но&nbsp;лично вам с&nbsp;этими запросами может больше подойти что-то другое.
                        Иногда психологи комбинируют несколько методов, чтобы сделать терапию более
                        индивидуальной и&nbsp;эффективной.
                    </p>
                    <p className="mb-3">
                        Как правило, любая терапевтическая сессия&nbsp;— это разговор о&nbsp;том,
                        что тревожит клиента, выстроенный на&nbsp;основе специальных техник. Также
                        многие психологи дают домашние задания&nbsp;— это может быть ведение
                        дневника, отработка определенных навыков, применение техник осознанности.
                    </p>
                </>
            ),
        },
        {
            title: <>Можно&nbsp;ли проходить психотерапию онлайн</>,
            content: (
                <>
                    Да. Вы&nbsp;можете проходить консультации удаленно&nbsp;&mdash; например,
                    по&nbsp;скайпу или в&nbsp;других сервисах видеосвязи. Цена не&nbsp;отличается
                    от&nbsp;офлайн-встреч с&nbsp;психологом. Большинство психологов Alter проводят
                    консультации онлайн&nbsp;&mdash; это стандартная практика. В&nbsp;целом это
                    отличный вариант для всех, у&nbsp;кого нет возможности встречаться
                    с&nbsp;психологом лично.
                </>
            ),
        },
        {
            title: "Что лучше: онлайн- или офлайн-терапия",
            content: (
                <>
                    <p className="mb-3">
                        Если есть возможность, лучше выбирать терапию офлайн&nbsp;— в&nbsp;этом
                        формате меньше ограничений и&nbsp;он&nbsp;может быстрее дать результаты.
                        Но&nbsp;если этот вариант не&nbsp;подходит&nbsp;— можно выбрать
                        онлайн-формат. Это стандартная практика. Цена не&nbsp;отличается
                        от&nbsp;офлайн-встреч с&nbsp;психологом.
                    </p>
                    <p className="mb-3">
                        Переписку рекомендуется использовать только в&nbsp;сочетании с&nbsp;другими
                        форматами, воспринимая ее&nbsp;как поддержку, но&nbsp;не&nbsp;как терапию.
                    </p>
                </>
            ),
        },
        {
            title: "Как психологи проходят проверку Alter",
            content: (
                <>
                    <p className="mb-3">
                        Только&nbsp;{PERCENT_OF_SELECTED_PSYCHOLOGISTS} психологов проходят
                        в&nbsp;Alter. Все наши психологи прошли отбор по&nbsp;методике,
                        разработанной на&nbsp;базе ПИ&nbsp;РАО&nbsp;&mdash; старейшего в&nbsp;России
                        научно-исследовательского психологического учреждения (1912г.).
                    </p>
                    <p className="mb-3">
                        В&nbsp;России отсутствуют лицензирование психологов и&nbsp;законы
                        о&nbsp;психологической помощи: никто не&nbsp;проверяет образование, качество
                        работы и&nbsp;адекватность методик практикующих специалистов. Alter решает
                        эту проблему.
                    </p>
                    <p className="mb-3">
                        Все наши психологи имеют соответствующее образование, они компетентны, умеют
                        работать с&nbsp;обозначенными в&nbsp;профилях кейсами и&nbsp;практикуют
                        в&nbsp;методах, признанных в&nbsp;профессиональном сообществе.
                    </p>
                </>
            ),
        },
    ],
}

export const aboutBooking = {
    title: <>Запись к&nbsp;психологу</>,
    content: [
        {
            title: <>Как записаться к&nbsp;психологу</>,
            content: (
                <>
                    <p className="mb-3">Чтобы записаться к&nbsp;психологу:</p>
                    <ol className="pl-3 ml-0 sb-3 mb-3">
                        <li>
                            <span>
                                Нажмите на&nbsp;кнопку «Записаться» на&nbsp;странице профиля
                                психолога.
                            </span>
                        </li>
                        <li>
                            <span>
                                Выберите вид сессии (индивидуально, семейная терапия/с партнером,
                                онлайн/офлайн).
                            </span>
                        </li>
                        <li>
                            <span>Выберите дату и&nbsp;время сессии.</span>
                        </li>
                        <li>
                            <span>Оплатите сессию онлайн на&nbsp;сайте банковской картой.</span>
                        </li>
                    </ol>
                    <p className="mb-3">
                        Информация о&nbsp;психологе и&nbsp;месте встречи&nbsp;— придут на&nbsp;почту
                        и&nbsp;по&nbsp;SMS.
                    </p>
                    <p className="mb-3">
                        Обратите внимание, что при отмене или переносе сессии менее чем
                        за&nbsp;24&nbsp;часа до&nbsp;ее&nbsp;начала&nbsp;— оплата
                        не&nbsp;возвращается.
                    </p>
                </>
            ),
        },
        {
            title: "Как оплатить сессию",
            content: (
                <>
                    <p className="mb-3">
                        Оплатить сессию нужно на&nbsp;нашем сайте (после выбора даты
                        и&nbsp;времени). Это дает вам:
                    </p>
                    <ul className="list-disc ml-0 pl-3 sb-3 mb-3">
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Гарантии на&nbsp;возврат денег, если вы&nbsp;захотите отменить
                                сессию.
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Гарантии компенсации, если вам что-то не&nbsp;понравится (случай
                                рассматривается индивидуально).
                            </span>
                        </li>
                    </ul>
                    <p className="mb-3">
                        Обратите внимание, что при отмене или переносе сессии менее чем
                        за&nbsp;24&nbsp;часа до&nbsp;ее&nbsp;начала&nbsp;— оплата
                        не&nbsp;возвращается.
                    </p>
                    <p className="mb-3">
                        Ссылка на&nbsp;последующие записи приходят по&nbsp;SMS и&nbsp;в&nbsp;письмах
                        на&nbsp;вашу почту.
                    </p>
                </>
            ),
        },
        {
            title: "Как перенести или отменить сессию",
            content: (
                <>
                    <p className="mb-3">
                        Перенести или отменить сессию вы&nbsp;можете в&nbsp;
                        <Link to="/my/alter">вашем личном кабинете</Link>. Перенос сессии
                        и&nbsp;отмена с&nbsp;возвратом денежных средств возможны более, чем
                        за&nbsp;24&nbsp;часа до&nbsp;начала сессии.
                    </p>
                </>
            ),
        },
        {
            title: <>Можно&nbsp;ли вернуть деньги</>,
            content: (
                <>
                    <p className="mb-3">
                        Мы&nbsp;гарантируем возврат денег за&nbsp;сессию в&nbsp;течение
                        3&nbsp;рабочих дней, если вы&nbsp;захотите отменить
                        ее&nbsp;за&nbsp;24&nbsp;часа до&nbsp;начала.
                    </p>
                    <p className="mb-3">
                        Обратите внимание, при отмене или переносе сессии менее чем
                        за&nbsp;24&nbsp;часа до&nbsp;ее&nbsp;начала&nbsp;— оплата
                        не&nbsp;возвращается.
                    </p>
                </>
            ),
        },
    ],
}

export const ifYouAreNotSure = {
    title: <>Если вы&nbsp;не&nbsp;уверены</>,
    content: [
        {
            title: <>Ничего не&nbsp;знаю о&nbsp;подходах психотерапии, нужно&nbsp;ли</>,
            content: (
                <>
                    <p className="mb-3">
                        Чтобы ходить на&nbsp;психотерапию, не&nbsp;обязательно разбираться
                        в&nbsp;том, как она работает. Направления терапии отличаются теоретической
                        базой, набором методик и&nbsp;продолжительностью курса. Но&nbsp;вам
                        не&nbsp;обязательно понимать, что именно происходит на&nbsp;терапии
                        с&nbsp;теоретической точки зрения. Намного важнее личные ощущения
                        и&nbsp;контакт с&nbsp;психологом.
                    </p>
                    <p className="mb-3">
                        Наш алгоритм подбора работает так, что вам сразу предлагают психологов
                        в&nbsp;подходящих направлениях. То&nbsp;есть, не&nbsp;нужно изучать теорию
                        и&nbsp;сопоставлять ее&nbsp;со&nbsp;своей проблемой&nbsp;— мы&nbsp;уже
                        сделали это за&nbsp;вас.
                    </p>
                </>
            ),
        },
        {
            title: <>Не&nbsp;могу определиться с&nbsp;выбором психолога, что делать</>,
            content: (
                <>
                    <p className="mb-3">
                        Мы&nbsp;понимаем, что выбор психолога&nbsp;— это сложно. Хотим вас немного
                        успокоить: если психолог, которого вы&nbsp;выбрали из&nbsp;нашей подборки,
                        вам не&nbsp;подошел&nbsp;— вы&nbsp;можете посмотреть каталог психологов
                        и&nbsp;подобрать специалиста, задав нужные вам параметры.
                    </p>
                    <p className="mb-3">
                        Но&nbsp;если выбрать совсем не&nbsp;получается&nbsp;— можете написать нам,
                        мы&nbsp;поможем.
                    </p>
                </>
            ),
        },
        {
            title: "Нужен психолог близкому, как поступить",
            content: (
                <>
                    <p className="mb-3">
                        Психотерапия эффективна только тогда, когда человек сам твердо решил
                        измениться. Поэтому мы&nbsp;не&nbsp;советуем уговаривать близких идти
                        к&nbsp;психологу. Но&nbsp;это не&nbsp;значит, что надо бездействовать, когда
                        близкому человеку нужна помощь. Вы&nbsp;можете:
                    </p>
                    <ul className="list-disc ml-0 pl-3 sb-3 mb-3">
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Рассказать о&nbsp;таком инструменте, как психотерапия: как
                                он&nbsp;работает, почему помогает.
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Рассказать о&nbsp;своем опыте работы с&nbsp;психологом.
                            </span>
                        </li>
                        <li className="color-green-2">
                            <span className="color-blue-4">
                                Предложить вместе поискать психолога.
                            </span>
                        </li>
                    </ul>
                </>
            ),
        },
        {
            title: <>У&nbsp;меня сейчас недостаточно денег, можно как-то получить помощь</>,
            content: (
                <p className="mb-3">
                    Посмотрите список организаций, которые оказывают{" "}
                    <a
                        className="color-green-2 hover-green-3"
                        href={`${APP_PAGE_URL}/besplatnaya-psikhologicheskaya-pomosch`}
                    >
                        бесплатную психологическую помощь.
                    </a>
                </p>
            ),
        },
        {
            title: <>Не&nbsp;могу сформулировать темы для обсуждения с&nbsp;психологом</>,
            content: (
                <>
                    Это нормально: первые сессии с&nbsp;психологом часто отводятся на&nbsp;то, чтобы
                    сформулировать запрос. Мы&nbsp;не&nbsp;всегда понимаем, что именно с&nbsp;нами
                    не&nbsp;так, и&nbsp;к&nbsp;чему мы&nbsp;хотим прийти в&nbsp;итоге. Часть работы
                    психолога&nbsp;&mdash; помочь клиенту прояснить это для себя.
                </>
            ),
        },
    ],
}

export const aboutAlter = {
    title: <>О&nbsp;сервисе Alter</>,
    content: [
        {
            title: <>Почему Alter, а&nbsp;не&nbsp;рекомендации знакомых</>,
            content: (
                <>
                    <p className="mb-3">
                        Терапевт, который помог вашему знакомому, может оказаться некомпетентным
                        в&nbsp;решении именно вашей проблемы. Здесь велика вероятность просто
                        не&nbsp;угадать со&nbsp;специализацией: если психолог помог кому-то
                        выбраться из&nbsp;глубокой депрессии, это вовсе не&nbsp;значит, что
                        он&nbsp;сможет решить проблемы в&nbsp;семье. Кроме того, знакомому может
                        быть сложно оценить реальную компетентность психолога и&nbsp;свои
                        результаты.
                    </p>
                    <p className="mb-3">
                        Сервис подбора ориентируется исключительно на&nbsp;вашу проблему
                        и&nbsp;позволяет как можно точнее подобрать психолога персонально для вас.
                    </p>
                </>
            ),
        },
        {
            title: <>Какие у&nbsp;Alter преимущества</>,
            content: (
                <ul className="list-disc ml-0 pl-3 sb-3 mb-3">
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Тестируем психологов с&nbsp;помощью методики, разработанной на&nbsp;базе
                            ПИ&nbsp;РАО и&nbsp;основанной на&nbsp;научных исследованиях.
                        </span>
                    </li>
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Мы проверили больше 6000 специалистов и только 13&#37; попали в базу
                            Alter.
                        </span>
                    </li>
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Подбираем психологов, которые наиболее эффективно работают с&nbsp;вашим
                            запросом.
                        </span>
                    </li>
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Наш подбор мгновенный и&nbsp;конфиденциальный. В&nbsp;подборе
                            не&nbsp;задействованы третьи лица, операторы, не&nbsp;нужно оставлять
                            заявку и&nbsp;ждать, пока с&nbsp;вами свяжутся.
                        </span>
                    </li>
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Поддерживаем на&nbsp;протяжении терапии: присылаем анкеты, чтобы оценить
                            удовлетворенность работой, полезные чек-листы и&nbsp;инструкции.
                            Помогаем решать проблемы, если они возникают в&nbsp;ходе терапии.
                        </span>
                    </li>
                    <li className="color-green-2">
                        <span className="color-blue-4">
                            Записаться к&nbsp;психологу и&nbsp;оплатить сессию можно онлайн.
                        </span>
                    </li>
                </ul>
            ),
        },
        {
            title: "Как психологи проходят проверку",
            content: (
                <>
                    <p className="mb-3">
                        В&nbsp;России отсутствуют лицензирование психологов и&nbsp;законы
                        о&nbsp;психологической помощи: никто не&nbsp;проверяет образование, качество
                        работы и&nbsp;адекватность методик практикующих специалистов. Alter решает
                        эту проблему.
                    </p>
                    <p className="mb-3">
                        Все наши психологи прошли отбор по&nbsp;методике, разработанной на&nbsp;базе
                        ПИ&nbsp;РАО&nbsp;&mdash; старейшего в&nbsp;России научно-исследовательского
                        психологического учреждения (1912г.).
                    </p>
                    <p className="mb-3">
                        Только&nbsp;{PERCENT_OF_SELECTED_PSYCHOLOGISTS} психологов проходят отбор
                        в&nbsp;Alter.
                    </p>
                    <p className="mb-3">
                        Все наши психологи имеют соответствующее образование, они компетентны, умеют
                        работать с&nbsp;обозначенными в&nbsp;профилях кейсами и&nbsp;практикуют
                        в&nbsp;методах, признанных в&nbsp;профессиональном сообществе.
                    </p>
                </>
            ),
        },
        {
            title: "Почему нет отзывов",
            content: (
                <>
                    <p className="mb-3">
                        Терапия&nbsp;— сложный процесс, в&nbsp;ходе которого возникают самые разные
                        эмоции, в&nbsp;том числе негативные. Если психолог будет сконцентрирован
                        на&nbsp;том, чтобы клиенту было исключительно хорошо, это может мешать
                        процессу терапии. Цель специалиста&nbsp;— помочь клиенту,
                        а&nbsp;не&nbsp;получить хорошую оценку.
                    </p>
                    <p className="mb-3">
                        К&nbsp;тому&nbsp;же, все кейсы разные. Положительный отзыв от&nbsp;клиента
                        с&nbsp;одним запросом не&nbsp;гарантирует эффективную терапию в&nbsp;случае
                        с&nbsp;другой проблемой.
                    </p>
                    <p className="mb-3">
                        Тем не&nbsp;менее, мы&nbsp;собираем обратную связь о&nbsp;работе сервиса
                        и&nbsp;эффекте психотерапии в&nbsp;целом. На&nbsp;основе этого
                        мы&nbsp;составляем рейтинг удовлетворенности, который публикуем
                        на&nbsp;нашем сайте.
                    </p>
                </>
            ),
        },
        {
            title: "Как работает поддержка",
            content: (
                <>
                    <p className="mb-3">
                        Если у&nbsp;вас возникнут вопросы о&nbsp;записи, оплате или какие-то
                        технические сбои на&nbsp;сайте, вы&nbsp;всегда можете обратиться к&nbsp;нам
                        по&nbsp;почте:
                        <a href={"mailto:" + PSYALTER_SUPPORT_EMAIL}>{PSYALTER_SUPPORT_EMAIL}</a>
                    </p>
                    <p className="mb-3">
                        Обычно мы&nbsp;стараемся реагировать максимально быстро и&nbsp;отвечать
                        в&nbsp;течение рабочего дня.
                    </p>
                </>
            ),
        },
        {
            title: <>Как мы&nbsp;участвуем в&nbsp;вашей терапии</>,
            content: (
                <>
                    <p className="mb-3">
                        Мы&nbsp;отправляем всем клиентам Alter анкету на&nbsp;следующий день после
                        первой сессии и&nbsp;через месяц после начала терапии. Анкета помогает
                        отследить, насколько вам нравится работа с&nbsp;психологом, и&nbsp;насколько
                        эффективна терапия. Также мы&nbsp;по&nbsp;желанию отправляем образовательные
                        письма про психологию и&nbsp;психотерапию.
                    </p>
                    <p className="mb-3">
                        Если поступают жалобы, мы&nbsp;разбираем каждый случай и&nbsp;обсуждаем его
                        с&nbsp;психологом (только с&nbsp;разрешения клиента). По&nbsp;результатам
                        разбора принимаем меры&nbsp;— вплоть до&nbsp;удаления психолога
                        из&nbsp;базы. А&nbsp;клиенту мы&nbsp;бесплатно подбираем нового специалиста.
                    </p>
                </>
            ),
        },
    ],
}
